export default __webpack_public_path__ + "static/media/@thafavoreto.c8b1490f.jpg";